import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import LoadingFallback from "./components/LoadingFallback";
import SiteLayout from "./components/SiteLayout";
import HomePage from "./pages/HomePage";

const AboutPage = lazy(() => import("./pages/AboutPage"));
const BooksPage = lazy(() => import("./pages/BooksPage"));
const BookPage = lazy(() => import("./pages/BookPage"));
const ComingSoonBookPage = lazy(() => import("./pages/ComingSoonBookPage"));
const DiscussionGuidePage = lazy(() => import("./pages/DiscussionGuidePage"));
const LinksPage = lazy(() => import("./pages/LinksPage"));
const MusingsPage = lazy(() => import("./pages/MusingsPage"));
const MusingArticlePage = lazy(() => import("./pages/MusingArticlePage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));
const OptimiserUniversePage = lazy(() => import("./pages/OptimiserUniversePage"));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage"));

export default function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route element={<SiteLayout />}>
          <Route index element={<HomePage />} />
          <Route path="/books" element={<Suspense fallback={<LoadingFallback />}><BooksPage /></Suspense>} />
          <Route path="/musings" element={<Suspense fallback={<LoadingFallback />}><MusingsPage /></Suspense>} />
          <Route path="/musings/:slug" element={<Suspense fallback={<LoadingFallback />}><MusingArticlePage /></Suspense>} />
          <Route
            path="/books/the-universe-without-noise"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <BookPage />
              </Suspense>
            }
          />
          <Route
            path="/books/the-universe-without-noise/discussion-guide"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <DiscussionGuidePage />
              </Suspense>
            }
          />
          <Route
            path="/books/the-paradox-beyond-silence"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <ComingSoonBookPage bookSlug="the-paradox-beyond-silence" />
              </Suspense>
            }
          />
          <Route
            path="/books/the-forever-inside-nothing"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <ComingSoonBookPage bookSlug="the-forever-inside-nothing" />
              </Suspense>
            }
          />
          <Route
            path="/about"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <AboutPage />
              </Suspense>
            }
          />
          <Route
            path="/privacy"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <PrivacyPage />
              </Suspense>
            }
          />
          <Route
            path="/links"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <LinksPage />
              </Suspense>
            }
          />
          <Route
            path="/the-universe-of-the-optimiser-trilogy"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <OptimiserUniversePage />
              </Suspense>
            }
          />
          <Route
            path="*"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <NotFoundPage />
              </Suspense>
            }
          />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}
